module.exports = __webpack_public_path__ + "static/media/probabilities.27a0ea6a.npy";